import {StyleSheet, PixelRatio, StatusBar, Platform} from 'react-native';
import {scale} from "../../../../common/utils";

export default StyleSheet.create({
    tabFixedWrapper: {
        position: 'absolute',
        width: '100%',
        height: 8,
        top: 44
    },
    tabFixed: {
        marginTop: 2,
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowRadius: 8,
        shadowColor: "transparent"
    },
    tabContainerFixed: {
        overflow: 'scroll',
        marginTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
    },
    tabShadow: {
        position: 'absolute',
        top: 22,
        height: 160,
        width: '100%',
        zIndex: 0,
    },
    tabShadowImage: {
        width: '100%',
        height: 12
    },
    tabScrollWrapper: {
        width: '100%',
        height: 48,
        overflow: 'hidden'
    },
    tabHeight: {
        width: '100%',
        height: 60
    },
    tabWrapper: {
        zIndex: 10,
        marginTop: 4,
        height: 48,
        position: 'relative',
        backgroundColor: "#FFFFFF",
        shadowOffset: {
            width: 0,
            height: -2
        },
        shadowRadius: 12,
        shadowColor: "rgba(0,0,0,0.06)",
        elevation: 8,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    tabContainer: {
        zIndex: 99,
        flex: 1,
        height: 60,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        backgroundColor: '#ffffff',
        flexDirection: 'row',
        flexWrap: 'nowrap'
    },
    tabItem: {
        height: 48,
        marginLeft: 22,
        position: 'relative',
        paddingBottom: 11,
        paddingTop: 15,
    },
    activeTabItem: {
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(16),
        color: "#333333",
        zIndex: 10
    },
    tabItemTitle: {
        fontFamily: "PingFangSC-Regular",
        fontSize: scale(16),
        lineHeight: 22,
        color: "#999999",
    },
    tabItemActiveBlock: {
        width: 36,
        height: 8,
        borderTopLeftRadius: 6,
        borderTopRightRadius: 2,
        borderBottomRightRadius: 6,
        borderBottomLeftRadius: 2,
        backgroundColor: "#66E5EE",
        position: 'absolute',
        bottom: 12,
        left: '50%',
        marginLeft: -18
    },
    linearBlock: {
        borderTopRightRadius: 16,
        overflow: 'hidden',
        width: 60,
        height: 48,
        zIndex: 100,
        position: 'absolute',
        right: 0
    },
    blankBlock: {
        width: 60,
        height: 44
    }
});